
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">如何同步汇客软件模版消息？</div>
      <div class="panel-body">
        <span
          class="span1"
        >怎样同步汇客软件模板消息?同步汇客模板消息需要满足2个条件：首先，该公众号是认证服务号，并且在公众号后台申请开通了模板消息功能;其次，需要开通汇客软件账号，并将该公众号绑定汇客软件，在汇客软件公众号后台同步模板消息即可。</span>
        <p class="p1">一、如何申请开通模板消息功能?</p>
        <p class="span1">
          1、登录公众号后台，点击【添加功能插件】。
          <br />2、选择【模板消息】。
          <br />3、选择主营行业和副营行业，并输入申请理由，理由必须在20-500字之间。
          <br />4、填写完毕，点击【提交】。提醒：提交后，页面会出现该提示：请耐心等待审核结果，模版消息申请资料已经提交，审核需要2-3个工作日。所以接下来就是等审核了，审核通过后，就能使用了。
        </p>
        <p class="p1">二、如何同步汇客软件模板消息功能?</p>
        <p class="span1">
          1、公众号后台申请开通模板消息功能后，点击功能里面的【模板消息】进入模板消息模板添加页面，搜索并添加相应的模板消息模板;
          <br />2、登录汇客软件公众号管理平台后台，在【其他功能】里面找到【同步管理】，点击进入;
          <br />3、找到【模板消息】，点击下方的同步按钮即可。
          <br />4、同步完后，我们可以在【素材管理】、群发功能以及汇客软件客户端里面找到同步过来的模板消息;
          <br />5、选择需要推送的模板消息，设置好相应的内容即可推送给客户。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


